import React, { forwardRef } from "react";
import { TextField } from "@mui/material";
import useDebounce from "../../../../hooks/useDebounce";

/**
 * Componente de entrada para o número do produto com funcionalidade de debounce.
 * @param {Object} props As propriedades do componente.
 * @param {string} props.value O valor atual do campo de entrada.
 * @param {Function} props.onChange Uma função para lidar com a mudança de valor do campo.
 * @param {Function} props.onDebouncedChange Uma função a ser chamada com o valor debounced.
 * @param {boolean} props.isSearching Indica se a busca está pendente.
 */
const ValidateShipmentsInput = forwardRef(
  function ValidateMovementsShipmentsInput(
    {
      value,
      onChange,
      onDebouncedChange,
      isSearching,
      name,
      label,
      helperText = "",
    },
    ref
  ) {
    const { debouncedFn: debouncedAddProduct, isPending: isDebouncePending } =
      useDebounce(onDebouncedChange, 1000); // delay de 1s

    const handleInputChange = (e) => {
      const inputValue = e.target.value;
      onChange(inputValue); // Atualiza o estado do input imediatamente
      debouncedAddProduct(inputValue); // Dispara a função debounced
    };

    return (
      <TextField
        name={name}
        label={label}
        variant="outlined"
        size="small"
        value={value}
        onChange={handleInputChange}
        fullWidth
        inputRef={ref} // <- agora funciona corretamente
        helperText={
          isSearching || isDebouncePending ? "Buscando..." : helperText
        }
      />
    );
  }
);

export default ValidateShipmentsInput;
